<div class="header">
  <h5 class="mt-3 mb-3">{{ isEditMode ? 'Add Partnership' : 'Edit Partnership' }}</h5>
</div>
<form class="form" [formGroup]="formData">
  <div class="form-row">
    <div class="form-group col-md-6">
      <label for="input2">Name</label>
      <input matInput #input2 class="form-control" formControlName="Name">
      <div *ngIf="formData.get('Name').touched || flag">
        <mat-error class="errorFont" *ngIf="formData.get('Name').errors?.required">
          Name is Required
        </mat-error>
      </div>
    </div>
    <div class="form-group col-md-6">
      <label for="input4">Description</label>
      <input matInput class="form-control" #input4 formControlName="Description">
      <div *ngIf="formData.get('Description').touched || flag">
        <mat-error class="errorFont" *ngIf="formData.get('Description').errors?.required">
          Description is Required
        </mat-error>
      </div>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-6">
      <label for="input3">Type</label>
      <input matInput #input3 class="form-control" formControlName="Type">
      <div *ngIf="formData.get('Type').touched || flag">
        <mat-error class="errorFont" *ngIf="formData.get('Type').errors?.required">
          Type is Required
        </mat-error>
      </div>
    </div>
    <div class="form-group col-md-6">
      <label for="input1">Logo</label>
      <div class="custom-file pr-2">
        <input type="file" class="custom-file-input" [ngClass]="(!flag || selectedLogoFile?.name) ? '' : 'is-invalid'"
          accept=".png,.jpg,.jpeg,.svg" formControlName="Logo" (change)="onLogoFileChange($event.target?.files)"
          id="logoFile">
         
        <label class="custom-file-label"  for="logoFile">{{ selectedLogoFile?.name || 'Choose logo' }}</label>
      </div>
      <div class="error"
        *ngIf="formData.get('Logo').invalid && formData.get('Logo').touched && formData.get('Logo').errors">
        <mat-error class="errorFont" *ngIf="formData.get('Logo').errors?.required">
          Logo is Required
        </mat-error>
      </div>
    </div>
  </div>
  <button type="button" class="submit-btn" (click)="onSubmit()">Submit</button>
  <button type="button" class="cancelbtn" (click)="closeDialog()">Cancel</button>
</form>